import React, { useContext, useEffect, useCallback, useRef, useState } from "react";
import { UpdateContext } from "../main-context.js";
import login_css from "./login.module.css";
import { getFromDbIndex, bootstrap } from "../lib/comm.js";
import { useHistory } from "react-router-dom";

// Offline login is brokered by Keycloak (auth-code), not a form on the PWA.
// On load we try the cached bootstrap payload; if it is missing/stale we
// fetch it from /offline/bootstrap using the session cookie, and if that is
// unauthenticated (401) comm.js bootstrap() bounces the browser to the
// KC-hosted offline login. Credentials are never entered on this page.
export default function Login() {
  const update_context = useContext(UpdateContext);
  const history = useHistory();
  const started = useRef(false);
  const [message, set_message] = useState("Signing in…");

  const processResponse = useCallback(
    (res) => {
      if (res === "comm error" || !res) {
        return;
      }
      const groups = {};
      for (const group of res.groups) {
        groups[Object.keys(group)[0]] = group[Object.keys(group)[0]];
      }
      update_context.update_main_context((prev) => ({
        ...prev,
        equipmentTypes: res.equipmentTypes.reduce((prev, cur) => {
          prev[cur.id] = cur.name;
          return prev;
        }, {}),
        status: {
          ...prev.status,
          authorized: true,
          username: res.username,
          id: res.id,
          group: res.group,
          first_name: res.first_name,
          last_name: res.last_name,
          is_nata_user: res.is_nata_user,
          has_station: res.has_station,
          station_id: res.station_id,
          vendor_id: res.vendor_id,
          station: res.station,
          vendor: res.vendor,
          preferences: res.preferences,
          can_change_prefs: res.can_change_prefs,
          date_string: res.date_string,
          get_full_name: res.first_name + " " + res.last_name,
        },
        groups: groups,
      }));

      history.push(update_context.settings.subfolder);
    },
    [history, update_context]
  );

  const handleCacheResult = useCallback(
    (res) => {
      if (res !== "comm error") {
        // Fresh cached payload -- proceed straight into the app (works
        // offline, so accumulated inspections keep flowing).
        processResponse(res);
        return;
      }
      // No fresh cache. When online, fetch the payload over the cookie;
      // bootstrap() either returns the payload (and we proceed) or redirects
      // to Keycloak when the session is gone. When offline, there is nothing
      // we can do -- the first login requires a connection.
      if (navigator.onLine) {
        bootstrap(update_context).then(processResponse);
      } else {
        set_message(
          "No internet connection. Connect to sign in for offline use."
        );
      }
    },
    [processResponse, update_context]
  );

  useEffect(() => {
    if (started.current) {
      return;
    }
    started.current = true;
    getFromDbIndex("/offline/login", handleCacheResult, update_context, false);
  }, [handleCacheResult, update_context]);

  return (
    <div className={login_css["login-background"]}>
      <div className={login_css["center-container"]}>
        <div className="container">
          <div className={"row " + login_css["login-row"]}>
            <div className={"text-center " + login_css["login-window"]}>
              <div className={login_css.headerlogo}></div>
              <h2 className={login_css["login-title"]}>OFFLINE LOGIN</h2>
              <p>{message}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
